<template>
  <div class="item news">
    <div class="image">
      <picture v-if="result?.images?.previewImage">
        <source
          :srcset="result?.images?.previewImage?.url.toCropUrl(255, 235)"
          media="(min-width: 1420px)"
        />
        <source
          :srcset="result?.images?.previewImage?.url.toCropUrl(260, 240)"
          media="(min-width: 1050px)"
        />
        <source
          :srcset="result?.images?.previewImage?.url.toCropUrl(270, 250)"
          media="(min-width: 768px)"
        />
        <source
          :srcset="result?.images?.previewImage?.url.toCropUrl(335, 300)"
          media="(min-width: 450px)"
        />
        <source
          :srcset="result?.images?.previewImage?.url.toCropUrl(190, 190)"
          media="(min-width: 0px)"
        />
        <img
          :src="result?.images?.previewImage?.url.toCropUrl(255, 235)"
          :alt="result?.images?.previewImage?.altText"
        />
      </picture>
      <img v-else src="/assets/images/Placeholder.png" />
    </div>

    <div class="text">
      <span class="tag" v-if="previewTagHeader">{{ previewTagHeader }}</span>
      <a :href="result.url">
        <span class="title">
          {{ result?.pageTitle }}
        </span>
      </a>
      <p class="date" v-if="dateString">
        {{ dateString }}
      </p>
    </div>
  </div>
</template>
<script lang="ts">
import { defineComponent, PropType } from "vue";
import { ISiteSearchResultItem } from "../../clients/search/src/models";
import { SpecificDateTimeFormatOptions } from "core-js";

export default defineComponent({
  props: {
    result: {
      type: Object as PropType<ISiteSearchResultItem>,
      required: true,
      default: (): ISiteSearchResultItem => { return {} }
    },
    language: {
      type: String,
      required: false,
      default: "",
    }
  },
  computed: {
    resultUrl() {
      const urlParts: string[] = [window.location.origin, this.result?.url];

      return urlParts
        .map(url => (url ? url.replace(/^\/+|\/+$/g, "") : ""))
        .join("/");
    },
    previewTagHeader() {
      if (this.result?.additionalFieldsMultiLingual?.previewTagHeader) {
        return this.result.additionalFieldsMultiLingual.previewTagHeader.split(",")[0];
      }
      return "";
    },
    dateString() {
      if (this.result?.additionalFields?.datestamp) {
        const dateOptions: SpecificDateTimeFormatOptions = {
          year: 'numeric',
          month: 'short',
          day: '2-digit',
        };

        return new Date(this.result.additionalFields.datestamp).toLocaleDateString(this.language, dateOptions);
      } else if (this.result?.additionalFields?.displayDate) {
        return this.result?.additionalFields?.displayDate;
      }
    }
    }
});
</script>
